<p-dialog [(visible)]="openSQDialog" [modal]="true" styleClass="sample-quantity-dialog"
    (onHide)="closeSampleQuantityDialog()">
    <p-header>
        <div class="d-flex flex-column">
            <p class="m-0 d-block sample-quantity-header">{{'vbeiRequiredSampleQuantityTitle' | translate}}</p>
            <p class="sample-quantity-info d-block">{{'vbeiRequiredSampleQuantityInfo' | translate}}</p>
        </div>
        <a class="ei ei-20 ei-download2 btn-download" (click)="exportAsPDF()"></a>
    </p-header>
    <p-table [columns]="cols" [value]="displaySamples" [scrollable]="true" scrollHeight="55vh"
        class="sample-quantity-table small-table">
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <ng-container *ngFor="let col of columns">
                    <col [ngStyle]="{'width': (col.width) ? (col.width + 'px') : ''}">
                </ng-container>
            </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns; let i = index" [ngClass]="{'p-l-24': i === 0}">
                    <span class="cell-content">{{col.header}}</span>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-sample let-rowIndex="rowIndex">
            <tr *ngFor="let analyses of sample.sampleQuantityDetails; let ai = index">
                <td [attr.rowspan]="sample.sampleQuantityDetails.length" class="sample-cell p-l-24" *ngIf="ai === 0">
                    {{sample.customerReference}}
                </td>
                <td [ngClass]="{'b-b-0': ai < (sample.sampleQuantityDetails.length - 1)}">
                    <span class="bold">[{{analyses.invoiceableItemCode}}]</span>&nbsp;{{analyses.invoiceableItemName}}
                </td>
                <td [ngClass]="{'b-b-0': ai < (sample.sampleQuantityDetails.length - 1)}">
                    {{analyses.preferedSampleContainer}}
                </td>
                <td [ngClass]="{'b-b-0': ai < (sample.sampleQuantityDetails.length - 1)}">
                    <span *ngIf="analyses.minimumQuantity">
                        {{analyses.minimumQuantity}}&nbsp;{{analyses.unit}}
                    </span>
                    <span class="thin" *ngIf="!analyses.minimumQuantity">Unknown</span>
                </td>
                <td [ngClass]="{'b-b-0': ai < (sample.sampleQuantityDetails.length - 1)}">
                    <span *ngIf="analyses.optimalQuantity">
                        {{analyses.optimalQuantity}}&nbsp;{{analyses.unit}}
                    </span>
                    <span class="thin" *ngIf="!analyses.optimalQuantity">Unknown</span>
                </td>
            </tr>
            <tr *ngIf="sample.sumOfMinimumQuantity.length > 0 && sample.sumOfOptimalQuantity.length > 0">
                <td colspan="3">{{ 'vbeiTotalSampleQuantityRequired' | translate }}</td>
                <td [innerHTML]="formatContent(sample.sumOfMinimumQuantity)"></td>
                <td [innerHTML]="formatContent(sample.sumOfOptimalQuantity)"></td>
            </tr>
        </ng-template>
    </p-table>
    <p-footer>
        <div class="text-left">
            <p class="m-0 d-block sample-quantity-more-info">{{'vbeiRequiredSampleQuantityMoreInfo' | translate}}</p>
        </div>
    </p-footer>
</p-dialog>

<p-toast position="top-right" key="requiredSampleQuantityError"></p-toast>